export { default as AgeSwiperStep } from './age-swiper';
export { default as FinalStep } from './final-step';
export { default as LoginStep } from './login';
export { default as OtpStep } from './otp';
export { default as RegionSelectStep } from './region-select';
export { default as RegisterStep } from './register';
export { default as RoleSelectStep } from './role-select';
export { default as SubjectSelectStep } from './subject-select';
